export const environment = {
    apiUrl: "https://api.pschool.ca",
    isBeta: true,
    production: true,
};
